import { AbstractControl, ValidatorFn } from '@angular/forms';

export function PatternValidator(pattern: string | RegExp): ValidatorFn {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (control: AbstractControl): { [key: string]: any } | null => {
    const getVal = (ctrl: AbstractControl): string =>
      ctrl && ctrl.value && ctrl.value.value ? ctrl.value.value : null;
    const val = getVal(control);
    if (val) {
      return !val.match(pattern)
        ? {
            pattern: {
              value: val,
              match: pattern
            }
          }
        : null;
    } else {
      return null;
    }
  };
}

export function PasswordValidator(pattern: string | RegExp): ValidatorFn {
  return (control: AbstractControl) => {
    const userNameValue = control.parent?.value?.userName?.value;
    const PasswordValue = control.value?.value;
    if (userNameValue && PasswordValue) {
      return PasswordValue.toLowerCase().includes(userNameValue.toLowerCase())
        ? {
            pattern: {
              value: PasswordValue,
              match: pattern
            }
          }
        : null;
    }
    return null;
  };
}

export function UserBasedPwdValidator(pattern: string | RegExp): ValidatorFn {
  return (control: AbstractControl) => {
    setTimeout(() => {
      const userNameValue = control.parent?.value?.userName?.value;
      const PasswordValue = control.parent?.value?.passwordText?.value;
      if (userNameValue && PasswordValue) {
        if (validatePassword(PasswordValue, userNameValue, pattern)) {
          control.parent.get('passwordText')?.setErrors({
            pattern: {
              value: PasswordValue,
              match: pattern
            }
          });
        } else {
          control.parent.get('passwordText')?.setErrors(null);
        }
      }
    }, 0);
    return null;
  };
}

const validatePassword = (
  PasswordValue: string,
  userNameValue: string,
  pattern: string | RegExp
): boolean => {
  return (
    PasswordValue.toLowerCase().includes(userNameValue.toLowerCase()) ||
    !PasswordValue.match(pattern)
  );
};
